'use strict';

import * as dom from './lib/dom.js';

const goToCatgory = (e) => {
    e.preventDefault();
    const el = e.target;
    const url = el.getAttribute('data-url');
    window.location.href = url;

}

const goToCatgoryNewTab = (e) => {
    e.preventDefault();
    const el = e.target;
    const url = el.getAttribute('data-url');
    window.open(url, "_blank");
}

export default function(){
    const categoryLinks = document.querySelectorAll('.js-category-link');
    if (categoryLinks.length > 0) {
        dom.forEachEl(categoryLinks, (el) => {
            const elParent = dom.parents(el, 'c-post-card__link');

            el.addEventListener('click', goToCatgory);
            el.addEventListener('auxclick', function(e) {
                if (e.button == 1) {
                    goToCatgoryNewTab(e)
                }
            })

            el.addEventListener('mouseenter', function(e) {
                dom.addClass(elParent, 'c-post-card--not-hover')
            });

            el.addEventListener('mouseleave', function(e) {
                dom.removeClass(elParent, 'c-post-card--not-hover')
            })
        });
    }
    
}
